(function () {
  function initTestimonials(root) {
    var section = root.matches && root.matches('[data-section-type="devora-testimonial-carousel"]')
      ? root
      : root.querySelector
        ? root.querySelector('[data-section-type="devora-testimonial-carousel"]')
        : null;
    if (!section || section.getAttribute('data-devora-ready') === '1') return;

    var slides = section.querySelectorAll('.devora-testimonials__slide');
    if (slides.length < 2) return;
    section.setAttribute('data-devora-ready', '1');

    var prev = section.querySelector('.devora-testimonials__arrow--prev');
    var next = section.querySelector('.devora-testimonials__arrow--next');
    var currentEl = section.querySelector('.devora-testimonials__current');
    var index = 0;
    var timer = null;
    var interval = parseInt(section.getAttribute('data-autoplay'), 10) || 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      if (currentEl) currentEl.textContent = String(index + 1);
    }

    function schedule() {
      if (timer) clearInterval(timer);
      if (interval > 0) {
        timer = setInterval(function () {
          show(index + 1);
        }, interval);
      }
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(index - 1);
        schedule();
      });
    }
    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(index + 1);
        schedule();
      });
    }

    schedule();
  }

  function initBrandTabs(section) {
    var tabs = section.querySelectorAll('.devora-brand-tabs__tab');
    var panels = section.querySelectorAll('.devora-brand-tabs__panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab-index');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-tab-panel') === idx;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function replaceNode(node) {
    if (!node || !node.parentNode) return node;
    var clone = node.cloneNode(true);
    node.parentNode.replaceChild(clone, node);
    return clone;
  }

  function initDevoraHeroFadeZoom(section) {
    var slideshow = section.querySelector('.slideshow');
    if (!slideshow || slideshow.dataset.devoraFadeZoomInit) return;

    function boot() {
      if (!slideshow.classList.contains('slideshow--loaded')) {
        setTimeout(boot, 80);
        return;
      }

      slideshow.dataset.devoraFadeZoomInit = '1';
      slideshow.classList.add('slideshow--devora-fade-zoom');

      var slides = Array.prototype.slice.call(section.querySelectorAll('.slide'));
      if (slides.length < 1) return;

      var autoplayMs = parseInt(slideshow.getAttribute('data-autoplay'), 10) || 5000;
      var transitionMs = 900;
      slideshow.style.setProperty('--devora-hero-duration', autoplayMs / 1000 + 's');
      slideshow.style.setProperty('--devora-hero-transition', transitionMs / 1000 + 's');

      slides.forEach(function (slide) {
        slide.style.display = 'block';
        slide.style.opacity = '';
      });

      var index = slides.findIndex(function (slide) {
        return slide.classList.contains('active');
      });
      if (index < 0) index = 0;

      var transitioning = false;
      var autoplayTimer = null;

      function syncDots() {
        var dots = section.querySelectorAll('.jump-to-slide li');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === index);
        });
      }

      function resetImgAnimation(slide) {
        var img = slide && slide.querySelector('img');
        if (!img) return;
        img.style.animation = 'none';
        void img.offsetWidth;
        img.style.animation = '';
      }

      function goTo(nextIndex) {
        if (transitioning || nextIndex === index || !slides[nextIndex]) return;
        transitioning = true;

        var prev = slides[index];
        var next = slides[nextIndex];

        slides.forEach(function (slide) {
          slide.style.opacity = '';
        });

        next.style.display = 'block';
        next.classList.add('devora-hero-visible', 'devora-hero-entering');
        next.classList.remove('devora-hero-leaving');
        prev.classList.add('devora-hero-leaving', 'devora-hero-visible');
        prev.classList.remove('devora-hero-entering');

        requestAnimationFrame(function () {
          prev.classList.remove('active');
          next.classList.add('active');
        });

        syncDots();

        window.setTimeout(function () {
          prev.classList.remove('devora-hero-leaving', 'devora-hero-visible', 'active');
          next.classList.remove('devora-hero-entering');
          next.classList.add('devora-hero-visible');
          prev.style.opacity = '';
          next.style.opacity = '';
          resetImgAnimation(next);
          index = nextIndex;
          transitioning = false;
        }, transitionMs);
      }

      function scheduleAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
        if (autoplayMs <= 1 || slides.length < 2) return;
        autoplayTimer = setInterval(function () {
          if (slideshow.dataset.devoraHeroTouchPause === '1') return;
          goTo((index + 1) % slides.length);
        }, autoplayMs);
      }

      slides[index].classList.add('devora-hero-visible', 'active');
      syncDots();

      /* Block Atlantic's 200ms jQuery fade + autoplay (causes lag/jump). */
      slideshow.classList.add('paused');

      replaceNode(section.querySelector('.next'));
      replaceNode(section.querySelector('.prev'));

      var nextBtn = section.querySelector('.next');
      var prevBtn = section.querySelector('.prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          goTo((index + 1) % slides.length);
          scheduleAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          goTo((index - 1 + slides.length) % slides.length);
          scheduleAutoplay();
        });
      }

      section.querySelectorAll('.jump-to-slide li').forEach(function (dot, dotIndex) {
        var freshDot = replaceNode(dot);
        freshDot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          goTo(dotIndex);
          scheduleAutoplay();
        });
      });

      scheduleAutoplay();
    }

    boot();
  }

  function initNativeSlideshowTouch(root) {
    var slideshow = root.querySelector('.slideshow');
    if (!slideshow || slideshow.dataset.devoraTouchInit) return;
    slideshow.dataset.devoraTouchInit = '1';

    var viewport = slideshow.querySelector('[data-slideshow-viewport]');
    if (!viewport) return;

    var startX = 0;
    var startY = 0;
    var tracking = false;

    viewport.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
        slideshow.dataset.devoraHeroTouchPause = '1';
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function (event) {
        if (!tracking || !event.changedTouches.length) return;
        tracking = false;
        delete slideshow.dataset.devoraHeroTouchPause;

        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;

        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;

        var nextBtn = slideshow.querySelector('.next');
        var prevBtn = slideshow.querySelector('.prev');

        if (dx < 0 && nextBtn) nextBtn.click();
        else if (dx > 0 && prevBtn) prevBtn.click();
      },
      { passive: true }
    );
  }

  function initSocialCarousel(section) {
    var trackWrap = section.querySelector('[data-devora-carousel-track-wrap]');
    if (!trackWrap) return;

    var prev = section.querySelector('[data-devora-carousel-prev]');
    var next = section.querySelector('[data-devora-carousel-next]');

    function scrollByDir(dir) {
      var slide = section.querySelector('.devora-social__slide');
      var amount = slide ? slide.offsetWidth + 14 : trackWrap.clientWidth * 0.8;
      trackWrap.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
  }

  function initLookbookCarousel(section) {
    var trackWrap = section.querySelector('[data-devora-lookbook-track-wrap]');
    var fill = section.querySelector('[data-devora-lookbook-progress-fill]');
    if (!trackWrap || !fill) return;

    function updateProgress() {
      var scrollable = trackWrap.scrollWidth - trackWrap.clientWidth;
      if (scrollable <= 0) {
        fill.style.width = '100%';
        fill.style.left = '0%';
        return;
      }

      var thumbWidth = (trackWrap.clientWidth / trackWrap.scrollWidth) * 100;
      var left = (trackWrap.scrollLeft / scrollable) * (100 - thumbWidth);
      fill.style.width = thumbWidth + '%';
      fill.style.left = left + '%';
    }

    trackWrap.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  function initSection(section) {
    var type = section.getAttribute('data-section-type');
    initTestimonials(section);
    if (type === 'devora-brand-tabs') initBrandTabs(section);
    if (type === 'devora-social-feed') initSocialCarousel(section);
    if (type === 'devora-shop-look') initLookbookCarousel(section);
    if (section.classList.contains('shopify-section--slideshow')) {
      initDevoraHeroFadeZoom(section);
      initNativeSlideshowTouch(section);
    }
  }

  function initAll() {
    document
      .querySelectorAll(
        '[data-section-type="devora-testimonial-carousel"], [data-section-type="devora-brand-tabs"], [data-section-type="devora-social-feed"], [data-section-type="devora-shop-look"], .shopify-section--slideshow'
      )
      .forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initSection(event.target);
  });
})();
